import { IBiometricIdentifiedDocumentDataInterface } from '@app/account-opening-module/interfaces';

export class BiometricVerifiedDocumentModel {
  public readonly documentType: string;
  public readonly firstName: string;
  public readonly lastName: string;
  public readonly dateOfBirth: string;
  public readonly city: string;
  public readonly street: string;
  public readonly state: string;
  public readonly postalCode: string;
  public readonly country: string;
  public readonly fullAddress: string;
  private readonly _data: IBiometricIdentifiedDocumentDataInterface[];
  // identifier is to get saved data from identities endpoint
  public readonly identifier: string;

  constructor(data: IBiometricIdentifiedDocumentDataInterface[], type: string, identifier: string) {
    this.identifier = identifier;
    this._data = Array.isArray(data) ? [...data] : [];
    this.documentType = type === '2' ? 'US Driver Licence Adult' : 'Unknown Document Type';
    this.firstName = this._getValue('SecondaryIdentifier');
    this.lastName = this._getValue('PrimaryIdentifier');
    this.dateOfBirth = this._getValue('DateOfBirth');
    this.city = this._getValue('AddressCity');
    this.street = this._getValue('AddressStreet');
    this.state = this._getValue('AddressJurisdictionCode');
    this.postalCode = this._getValue('AddressPostalCode');
    this.country = this._getValue('issuer');
    this.fullAddress = this._fullAddress;
  }

  private get _fullAddress(): string {
    return [
      this.street,
      this.city,
      this.state,
      this.postalCode
    ].filter(p => Boolean(p)).join(', ');
  }

  private _getValue(key: string): string {
    const item = this._data.find(d => d.Key.toLowerCase() === key.toLowerCase());

    return item ? item.Value : '';
  }
}
